import { WarehouseTranslations } from './zh';

export const warehouseEn: WarehouseTranslations = {
  // Page titles
  title: 'Warehouses',
  storageLocations: 'Locations',
  
  // Warehouse fields
  code: 'Warehouse Code',
  name: 'Warehouse Name',
  nameEn: 'English Name',
  nameCn: 'Chinese Name',
  description: 'Description',
  address: 'Address',
  contactPerson: 'Contact Person',
  contactPhone: 'Contact Phone',
  isDefault: 'Default Warehouse',
  sortOrder: 'Sort Order',
  
  // Location fields
  locationCode: 'Location Code',
  locationName: 'Location Name',
  zone: 'Zone',
  aisle: 'Aisle',
  rack: 'Rack',
  level: 'Level',
  position: 'Position',
  capacity: 'Capacity',
  
  // Status
  status: 'Status',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusMaintenance: 'Maintenance',
  statusFull: 'Full',
  statusReserved: 'Reserved',
  
  // Actions
  createWarehouse: 'Create Warehouse',
  editWarehouse: 'Edit Warehouse',
  deleteWarehouse: 'Delete Warehouse',
  createLocation: 'Create Location',
  editLocation: 'Edit Location',
  deleteLocation: 'Delete Location',
  viewLocations: 'View Locations',
  
  // Statistics
  warehouseCount: 'Warehouses',
  locationCount: 'Locations',
  partsCount: 'Parts',
  
  // Prompts
  deleteWarehouseConfirm: 'Are you sure you want to delete this warehouse? This action cannot be undone.',
  deleteLocationConfirm: 'Are you sure you want to delete this location? This action cannot be undone.',
  warehouseHasLocations: 'This warehouse has storage locations. Please delete them first.',
  locationHasParts: 'This location has parts. Please remove them first.',
  
  // Success/failure messages
  createSuccess: 'Created successfully',
  updateSuccess: 'Updated successfully',
  deleteSuccess: 'Deleted successfully',
  createFailed: 'Failed to create',
  updateFailed: 'Failed to update',
  deleteFailed: 'Failed to delete',
  
  // Form
  selectWarehouse: 'Select Warehouse',
  selectLocation: 'Select Location',
  allWarehouses: 'All Warehouses',
  allLocations: 'All Locations',
  noWarehouse: 'No warehouses',
  noLocation: 'No locations',
  
  // Search
  searchPlaceholder: 'Search warehouse code or name',
  searchLocationPlaceholder: 'Search location code or name',
  
  // Bulk import
  bulkImport: 'Bulk Import',
  downloadTemplate: 'Download Template',
  importFile: 'Import File',
  importSuccess: 'Import successful',
  importFailed: 'Import failed',
  importResult: 'Import Result',
  successCount: 'Success',
  failedCount: 'Failed',
  importErrors: 'Error Details',
  row: 'Row',
  dragOrClick: 'Drag file here or click to upload',
  supportFormat: 'Supports CSV, Excel formats',
  importing: 'Importing...',
  parseError: 'Failed to parse file',
};

